import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RiskScoreItem } from '../../../types';
import { corporateClientsRiskApi } from '../services';

export interface CorporateClientsDeliveryChannelsFormState {
  itemId?: string;
  item?: RiskScoreItem;
}

const initialState: CorporateClientsDeliveryChannelsFormState = {};

export const corporateClientsDeliveryChannelsFormSlice = createSlice({
  name: 'corporateClientsDeliveryChannels',
  initialState,
  reducers: {
    clearIndividualDeliveryChannelFormState: (state) => {
      state.itemId = undefined;
      state.item = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      corporateClientsRiskApi.endpoints.getCorporateDeliveryChannel
        .matchFulfilled,
      (state, action: PayloadAction<{ data: RiskScoreItem }>) => {
        state.item = action.payload.data;
        state.itemId = action.payload.data.id;
      },
    );
  },
});

export const { clearIndividualDeliveryChannelFormState } =
  corporateClientsDeliveryChannelsFormSlice.actions;

export default corporateClientsDeliveryChannelsFormSlice.reducer;
